/** TanStack Query key prefix for LIST table data in `usePassportRuntimeListTable` (invalidate with `[prefix, inventoryGroupObjectId]`). */
export const PASSPORT_RUNTIME_LIST_TABLE_QUERY_KEY = 'passport_runtime_list_table' as const
